import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
const IV = process.env.REACT_APP_IV;

export interface EncryptedData {
  encryptedData: string;
  IV: string;
}

export const encryptData = (plaintext: object | string): EncryptedData => {
  const keyWords = CryptoJS.enc.Utf8.parse(SECRET_KEY);
  const ivWords = CryptoJS.enc.Hex.parse(IV);

  const encrypted = CryptoJS.AES.encrypt(
    typeof plaintext === "string" ? plaintext : JSON.stringify(plaintext),
    keyWords,
    {
      iv: ivWords,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return {
    encryptedData: encrypted.ciphertext.toString(CryptoJS.enc.Hex),
    IV: IV,
  };
};

export const decryptData = (encryptedData: string, iv: string): object | string => {
  const keyWords = CryptoJS.enc.Utf8.parse(SECRET_KEY);
  const ivWords = CryptoJS.enc.Hex.parse(iv);

  const cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Hex.parse(encryptedData),
  });

  const decrypted = CryptoJS.AES.decrypt(cipherParams, keyWords, {
    iv: ivWords,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

  try {
    return JSON.parse(decryptedText); 
  } catch {
    return decryptedText; 
  }
};
